import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import useTheme from "@/hooks/useTheme";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppFloat } from "@/components/layout/WhatsAppFloat";
import { GridBackdrop } from "@/components/layout/GridBackdrop";
import { SmoothScroll } from "@/components/layout/SmoothScroll";
import Home from "@/pages/Home";
import Sourcing from "@/pages/Sourcing";
import ApiList from "@/pages/ApiList";
import Licensing from "@/pages/Licensing";
import RdCro from "@/pages/RdCro";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import CaseStudies from "@/pages/CaseStudies";
import Product from "@/pages/Product";
import News from "@/pages/News";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function App() {
  const { theme, toggle } = useTheme();
  return (
    <BrowserRouter>
      <SmoothScroll />
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-none focus:bg-ink focus:px-4 focus:py-2 focus:text-paper">
        Skip to content
      </a>
      <GridBackdrop />
      <Header theme={theme} onToggleTheme={toggle} />
      <main id="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sourcing" element={<Sourcing />} />
          <Route path="/active-pharmaceutical-ingredients" element={<ApiList />} />
          <Route path="/licensing" element={<Licensing />} />
          <Route path="/rd-cro-services" element={<RdCro />} />
          <Route path="/rd-services" element={<Navigate to="/rd-cro-services" replace />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/news" element={<News />} />
          <Route path="/products/:slug" element={<Product />} />
          <Route path="/privacy" element={<Legal doc="privacy" />} />
          <Route path="/terms" element={<Legal doc="terms" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster theme={theme} position="bottom-left" richColors />
    </BrowserRouter>
  );
}

export default App;
